import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TicketsInfo } from "@models/tickets-info";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class TicketsService {
  private readonly baseUrl = `${environment.API_BACKEND}`;

  constructor(private http: HttpClient) {}

  getTicketsInfo(interval: string) {
    const params = new HttpParams().set("interval", interval ?? "M");
    return this.http.get<TicketsInfo>(`${this.baseUrl}/tickets_filtered`, {
      params,
    });
  }
}
